import React from 'react';
import styles from './Features.css';
import { Trans } from 'react-i18next';
import classNames from 'classnames';

interface FeaturesProps {
  compareProduct?: string;
  featureList: string[];
  className?: string;
}

const Features = ({
  compareProduct,
  featureList,
  className
}: FeaturesProps): React.ReactElement => {
  return (
    <div className={classNames(styles.productDescription, className)}>
      {compareProduct ? (
        <Trans>
          <p>
            <strong>Extend the value of Pro:</strong>
          </p>
        </Trans>
      ) : (
        <p></p>
      )}
      <ul>
        {featureList.map(f => (
          <li key={f}>
            <span></span>
            {f}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Features;
